import type { I18n } from '@/typings/i18n'

const en: I18n = {
  global: {
    indexTitle: 'LOOK',
    tipsTitle: 'Tip',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    day: 'Day',
    people: 'Person',
    bindButtonText: 'Bind',
    help: 'Help',
    manageSubscription: 'Manage subscription',
    coupon: 'My Coupons',
    deleteMessage: 'Are you sure you want to delete?',
    deleteButtonText: 'Delete',
    renameButtonText: 'Rename',
    downloadButtonText: 'Download',
    install: 'installed',
    phoneNumberLabel: 'Mobile phone number',
    verificationCodeLabel: 'Verification code',
    sendButtonText: 'Send',
    saveButtonText: 'Save',
    download: 'Download',
    complete: 'Complete',
    adjustButtonText: 'Adjust',
    eraser: 'Eraser',
    undo: 'Undo',
    redo: 'Redo',
    clear: 'Clear',
    noDataMessage: 'No Data',
    loading: 'Loading',
    customize: 'Custom',
    referenceImage: 'Reference Image',
    styleImage: 'Style Image',
    high: 'High',
    middle: 'Middle',
    low: 'Low',
    big: 'Big',
    small: 'Small',
    select: 'Select',
    upload: 'Upload',
    colon: ':',
    uploadDesc: 'Click or drag files to this area to upload',
    generate: 'Generate',
    preview: 'Preview',
    magic: 'Intelligent',
    add: 'Add',
    subtract: 'Reduce',
    brush: 'Brush',
    part: 'Partial',
    commonlyUsed: 'History',
    recommend: 'Recommend',
    termsOfService: 'Terms of Service',
    userAgreement: 'User Agreement',
    privacyStatement: 'Privacy Statement',
    wechat: 'WeChat',
    xiaohongshu: 'Xiaohongshu',
    downloadClient: 'download the client',
    ok: 'Okay',
    and: ' and ',
    language: 'Language',
    copy: 'Copy',
    copyLink: 'Copy Link',
    signupTitle: 'Signup',
    signupTitleSuffix: 'LOOK AI Real-Time Fashion Design Tool',
    recentsTitle: 'Recents - LOOK',
    projectNameTitle: '{projectName} - LOOK',
    nextStep: 'Next Step',
    accept: 'Accept',
    reject: 'Reject',
    about: 'About',
    close: 'Close',
    skip: 'Skip',
    iKnow: 'I know'
  },
  system: {
    updateTip: 'The new version has been downloaded. Click to update.',
    updateMessage: 'Are you sure you want to close the application and install the update?',
    drawingDownMessage: ' feature requires downloading the client.',
    bonjourInstallTitle: 'Bonjour not installed',
    bonjourInstallMessage1: 'Screen mirroring reception service not installed detected. ',
    bonjourInstallMessage2:
      ' feature cannot function properly. Please download and install bonjour, then restart LOOK.',
    bonjourInstallMessage3: 'If the download still does not work, click still cannot use.',
    bonjourUnavailableTitle: 'Bonjour installation unsuccessful',
    bonjourUnavailableMessage1: 'Screen mirroring reception service not installed detected. ',
    bonjourUnavailableMessage2: 'Please follow the video guide to force uninstall',
    bonjourUnavailableMessage3:
      'Please reinstall the screen mirroring reception service, then restart LOOK.',
    bonjourUnavailableMessage4:
      'If it still does not work after downloading, please visit our Discord:',
    bonjourStartTitle: 'Bonjour not properly started',
    bonjourStartMessage1:
      'Screen mirroring reception service not properly started detected. The real-time design feature cannot function properly. Please follow the guide steps to start.',
    bonjourStartMessage2: 'then',
    bonjourStartMessage3: 'restart LOOK',
    bonjourStartMessage4: '1、Open system settings, search for "services"',
    bonjourStartMessage5: '2、Right-click Bonjour in the services, select "Start"',
    bonjourStartMessage6: '3、Reopen LOOK to use',
    bonjourStartMessage7: 'If it still does not work after restarting, please visit our Discord:',
    bonjourStartText: 'properly started',
    bonjourUnavailable: 'feature cannot function properly',
    bonjourDownload: 'Bonjour Download',
    revoUninstaller: 'Revo Uninstaller',
    forceUninstallMessage:
      'Note: If you have installed the screen mirroring reception service but still repeatedly receive prompts that the service is not installed, it may be because the installation was not completely successful. You can try using a powerful uninstallation tool to uninstall both Bonjour and Bonjour SDK applications, and then try reinstalling the screen mirroring reception service.',
    guideButtonText: 'Tutorial',
    noImageMessage: 'No image selected',
    aboutUsTitle: 'About Us',
    weChatPublicAccountTitle: 'WeChat Official Account',
    error400: 'Invalid request parameters',
    error403: 'Access Denied',
    error404: 'Request address not found',
    error408: 'Request Timeout',
    error500: 'Internal Server Error',
    error501: 'Server Not Implemented',
    error502: 'Gateway Error',
    error503: 'Service Unavailable',
    error504: 'Gateway Timeout',
    copySuccess: 'Copy Successful',
    copyError: 'Copy Failed：',
    browserTips: 'For a better user experience, please use the Chrome browser to access or ',
    serviceStopMessage:
      'Your Pro subscription has not been automatically renewed on {date}. If you do not pay before the deadline, the service will be stopped.',
    renewalReminderMessage: 'If you need to continue using it, please',
    paymentLink: 'click to complete the subscription payment',
    updateTipsMessage:
      'LOOK has detected a new version and will automatically close to install the update.',
    osVersionNotSupportedMessageWindows:
      'Operating system versions below Windows 10 64-bit are not supported, which may affect your user experience. It is recommended to upgrade your operating system or access via a browser.',
    osVersionNotSupportedMessageMacOS:
      'Operating system versions below Mac OS 13 are not supported, which may affect your user experience. It is recommended to upgrade your operating system or access via a browser.',
    updatedDownloadMessage:
      'LOOK has detected a new version and will automatically close to install the update.',
    receiverConnectErrorMessage: 'Screen mirroring receiver connection error:{message}',
    receiverStartErrorMessage: 'Screen mirroring receiver startup error:{message}',
    macOSVersionErrorMessage:
      'Screen mirroring receiver startup error: Mac OS version is too low, please upgrade your operating system.',
    airplayRTPErrorMessage:
      'AirPlay screen mirroring encountered a network error. Please check your network connection and try restarting LOOK.',
    networkDisconnectedMessage:
      'Network connection lost, screen mirroring stopped. Please check your network connection.',
    networkReconnectedMessage:
      'The network has been reconnected. To continue streaming, please restart LOOK and reconnect your device.',
    slogan1: 'AI Real-Time Fashion Design Tool',
    slogan2: 'Bring Your Ideas to Life Instantly!',
    slogan3: 'Design in Real-Time, See Real Results',
    slogan4: 'Turn sketches into renderings instantly, generate multiple variations',
    slogan5: 'Style Fusion: Break the boundaries of imagination',
    slogan6: 'Partial Adjustment: Precise control with AI',
    networkErrorMessage:
      "Network is currently not connected. Please check your device's network settings.",
    serverErrorMessage: 'Server access failed, please try again later',
    languageChangeMessage:
      'Switching to this language requires a re-login. Are you sure you want to switch?',
    downloadAppMessage:
      'First-time download and login to the app for an <br/><span style="font-weight: 700; font-size: 24px">EXTRA 1-DAY Free trial</span>',
    downloadButtonTextMac: 'Download for macOS',
    downloadButtonTextWindows: 'Download for Windows',
    consentTitle: 'Cookie Notice',
    consentTips:
      'To provide you with a better service and personalized experience, we use cookies and similar technologies to analyze website performance, display personalized ads, and provide social media features.  By clicking "Accept All Cookies" or by continuing to use this site, you consent to other analytical cookies and tracking cookies which allow FedEx to provide a more personalized experience. See our <span style="font-weight: 700; text-decoration: underline; cursor: pointer">Cookie Policy</span> to learn more about the cookies we use.',
    aboutTitle: 'LOOK Desktop App',
    currentVersion: 'Version',
    newVersion: 'New Version',
    copyright: 'Copyright © 2024 LOOK AI LIMITED',
    checkUpdateButtonText: 'Check Update',
    updateButtonText: 'Update to {version}',
    noUpdateMessage: 'Already the latest version',
    updateFailMessage: 'Update failed, LOOK will attempt to update again after restart',
    appDownloadGuideTitle: 'Download LOOK Desktop Client',
    appDownloadGuideSubTitle: 'This feature requires downloading the LOOK desktop client.',
    realtimeDesignGuideTitle: 'Real-Time Design Guide',
    realtimeDesignGuideSubTitle1:
      'Real-Time Design requires downloading the <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> LOOK desktop client and using it together with the <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> Procreate app.',
    realtimeDesignGuideSubTitle2:
      'Please open <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> Procreate and <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> LOOK desktop client, then follow the guide to complete screen mirroring connection.',
    freeCountLimitDialogTitle: 'Generation Limit Reached?',
    freeCountLimitDialogDesc:
      'First-time download and login to the app for an <br/><span style="font-weight: 600; font-size: 24px">EXTRA 1-DAY Free trial</span>',
    freeCountLimitDialogDescMobile:
      'First-time download and login to the app on<br/><span style="font-weight: 600">PC or macOS</span> for an <br/><span style="font-weight: 600;font-size: 24px">EXTRA 1-DAY Free trial</span>',
    imageSizeTooLarge: 'Image size cannot be larger than {size}MB'
  },
  error: {
    invitationCodeUsed: 'Invitation code already used',
    invitationCodeInvalid: 'Invitation code invalid',
    networkErrorTitle: 'Network Error',
    networkErrorMessage:
      'Unable to connect to the server. Please check your network connection and try again.',
    retryButtonText: 'Retry',
    upscaleScaleError:
      'Upscale is not permitted. Please upgrade your plan to unlock higher image quality.',
    campaignSystemError: 'System error, please try again later',
    campaignUserAuthError: 'Failed to get user identity',
    campaignParamError: 'Parameter error',
    campaignQueryError: 'Query error',
    campaignNotCompleted: 'Activity task not completed',
    campaignRewardAlreadyClaimed: 'Reward already claimed',
    campaignCouponNotAvailable: 'Coupon not available',
    campaignUseCoupon: 'Failed to use coupon',
    campaignAssignCoupon: 'Failed to assign coupon',
    userGoogleAuthFail: 'Google login failed',
    userNotSupportLoginType: 'Unsupported login type',
    userSystemError: 'System error',
    userLoginError: 'Login failed'
  },
  account: {
    logoutMessage: 'Are you sure you want to log out?',
    logoutButtonText: 'Log Out',
    bindPhoneTitle: 'Bind mobile phone',
    bindPhoneSuccessMessage: 'Mobile phone binding successful',
    bindPhoneTips: 'Bind your mobile number to get a free membership',
    bindPhoneEmptyNumberMessage: 'Please enter your mobile phone number',
    bindPhoneErrorNumberMessage: 'Not a valid mobile phone number',
    bindPhoneVerificationCodeEmptyMessage: 'Please enter the verification code',
    getInvitationCodeErrorMessage: 'Failed to retrieve invitation code information',
    trialDuration: 'Free Trial: ',
    headerGiftText: 'Claim Voucher',
    headerOneDayGiftText: '{discount}% Off Membership',
    headerSubscribeGiftText: 'Subscribe Now',
    invitePopoverTitle: 'Invite Friends, Get Rewards',
    invitePopoverDescTips:
      'New users binding their mobile phone is considered a successful invitation of a new user',
    invitePopoverMark: 'Claim&nbsp;<span>$15</span>&nbsp;Voucher!',
    invitePopoverDesc:
      'For each friend you invite, you will receive a $15 voucher that can be used for subscription/renewal! Your friend will get a 15-day free trial!',
    invitePopoverCodeShareTitle: 'Scan to Share',
    invitePopoverCodeCopyTitle: 'Click to Copy',
    invitePopoverShareCountText: 'Remaining Invites:',
    invitePopoverSubText:
      'The usage of invitation codes is automatically allocated based on usage.',
    invitePopoverGiftDaysText: 'Accumulated Vouchers:',
    invitePopoverBindPhoneMaskText:
      'Bind your mobile phone to activate and receive invitation slots',
    phoneNumber: 'Mobile number:',
    noMemberText: 'Free',
    memberExpireAtFormat: 'DD/MM/YYYY',
    memberExpireAt: 'Expiration date:',
    memberUpgradeMainText: 'Unlock higher generation limits for 4K images',
    memberUpgradeMainTextFirst: 'Get 50% OFF!',
    memberUpgradeSubText: 'Achieve Real-Time Design Freedom!',
    memberUpgradeLinkTextActivate: 'ACTIVATE',
    memberUpgradeLinkTextUpgrade: 'UPGRADE',
    memberUpgradeLinkTextGet: 'GET',
    memberUpgradeLinkTextManage: 'MANAGE',
    discordLoginTitle: 'Start with LOOK',
    discordLoginButtonText: 'Continue with Discord',
    discordLoginSubText1:
      'By signing up, you are creating a LOOK AI account and agree to LOOK AI’s ',
    discordLoginSubText2: '.',
    googleLoginButtonText: 'Continue with Google',
    invitePageTitle: 'Hello, designer',
    invitePageNicknamePlaceholder: 'Nickname',
    invitePageInvitationCodePlaceholder: 'Invitation code',
    invitePageSubmitButtonText: 'Get Started',
    invitePageTips:
      '<span style="font-weight: 700">EXTRA 8-DAY FREE TRAIL</span>&nbsp;with invitation code',
    invitePageInvitationCodeInvalid: 'Invitation code invalid',
    hasInvitationCodeText: 'I have an invitation code',
    shareInvitationCodeText: `LOOK AI Real-Time Fashion Design Tool

💻 PC Access: https://app.lookfashion.ai
📱 Currently not supported on mobile

Invitation Code: {code}`,
    limitedTitle: 'Slow down…',
    limitedTime: 'You can continue using the service after {time}',
    limitedRealtimeDesignTime: 'Please continue using in the next subscription cycle.',
    limitedSubject:
      'You have reached the generation limit for <span style="font-weight: 600">{name}</span>,',
    upgradeTitle: 'Tired of waiting?',
    upgradeSubject:
      'Upgrade membership to <span style="font-weight: 600">generate immediately</span>!',
    upgradeButtonText: 'Upgrade Now',
    mergeAccount: 'Is this you?',
    mergeAccountDesc: 'Yes, link account',
    mergeAccountCancel: 'No, return to login',
    recentLoginText: 'Last login'
  },
  project: {
    recentListTitle: 'Recent Generations',
    collectListTitle: 'Favorites List',
    projectListTitle: 'Project List',
    emptyMessage1: 'No projects created yet',
    emptyMessage2: 'Click below to create a project',
    emptyMessage3: 'Start generating',
    emptyMessage4: 'No images saved yet, generate and ',
    emptyMessage5: 'save to add images',
    emptyMessage6: 'First create a new project, then generate and ',
    emptyMessage7: 'save LOOK',
    createProjectButtonText: 'New Project',
    projectNamePlaceholder: 'Please enter the project name',
    projectEnterText1: 'Enter project',
    projectEnterText2: 'Enter the workspace',
    createProjectTip: 'Please create a project first'
  },
  image: {
    text2ImageTitle: 'Text-to-Image',
    originalityTitle: 'Sketch-to-Image',
    styleExtensionTitle: 'Style Extension',
    styleFuseTitle: 'Style Blending',
    tuneTitle: 'Area Adjustment',
    recolorTitle: 'Smart Recolor',
    backgroundTitle: 'AI Scene Change',
    eraserTitle: 'Magic Eraser',
    cutoutTitle: 'One-Click Cutout',
    flowerPatternExpansionTitle: 'seamless Tile',
    aiExpansionTitle: 'Image Extension',
    hdTitle: 'Upscale',
    drawingTitle: 'Real-Time Design',
    patternTitle: 'Pattern Mapping',
    imageCount: '',
    generateButtonText: 'Generate LOOK',
    generateButtonSubscribeBoxTitle1: '50% off for first-time subscribers',
    generateButtonSubscribeBoxTitle2: 'Unlock Professional Plan',
    generateButtonSubscribeBoxDesc1:
      'Free trial expired? Unlock more generation privileges now with a discount!',
    generateButtonSubscribeBoxDesc2: 'Upgrade to Pro to achieve Real-Time Design Freedom!',
    generateButtonSubscribeBoxButtonText1: 'Get Free Trial',
    generateButtonSubscribeBoxButtonText2: 'Upgrade to Pro Plan',
    originalSizeText: 'Ratio',
    uploadImageButtonText: 'Upload Image',
    uploadPatternButtonText: 'Upload Pattern',
    editMaskButtonText: 'Edit Mask',
    removeMaskButtonText: 'Delete Mask',
    imageUploaderDesc:
      '<span style="color: #4c4c4c; font-size: 14px">Click or drag to upload</span><br/> <span style="color: #b0b2ae; font-size: 12px">(Images in the save area below and to the right can be dragged directly)</span>',
    generatePreviewText: 'Generate Preview({count}/{max})',
    previewListHelpMessage1:
      'The generated images are temporarily stored in this list, up to {max} images. When it exceeds {max} images, the earliest generated image will be deleted.',
    previewListHelpMessage2:
      'Temporary images need to be saved to the album for permanent storage and to perform more actions.',
    clearPreviewButtonText: 'Clear All Previews',
    segmentErrorMessage: 'Image semantic analysis failed, please try again',
    generatingMessage: 'Image generation in progress',
    previewWaitingMessage: 'Image processing, please wait',
    previewFailedMessage: 'Image processing failed, unable to view',
    imageInQueueMessage: 'Queue',
    imageNotVerifyMessage: 'Violation',
    saveImageButtonText: 'Save to album',
    deleteTmpImageButtonText: 'Delete temporary images',
    previewImageInfoText: 'Image Information',
    promptDefaultPlaceholder:
      'Enter a description of the design or prompt words to improve generation accuracy',
    promptDefaultPlaceholder2: 'Enter a description of the pattern',
    promptDefaultPlaceholder3: 'Enter a description of the image',
    promptDefaultPlaceholder4: 'Enter a description of the model\'s hairstyle',
    removeBgErrorMessage: 'Background removal failed',
    removeBgButtonText: 'Remove background',
    removeBgLoadingMessage: 'Removing background, please wait',
    cropTip1:
      "Try to leave enough space at the top and bottom of the image to generate the model's head and legs",
    cropTip2: 'If the uploaded image is too small, please crop it to an appropriate size',
    diyModelText: 'Custom Model',
    commonModelText: 'Public Model',
    exclusiveModelText: 'Exclusive Model',
    promptTitle: 'Prompt',
    promptTitle2: 'Flower Pattern Description',
    promptTitle3: 'Image Description',
    promptTitle4: 'Hairstyle Description',    
    promptInputTitle: 'Design Features (Multiple Selection)\n',
    selectModelTitle: 'Model Selection',
    referenceStrengthLabel: 'Reference Strength',
    modelSettingTitle: 'Model Settings',
    advancedSettingsTitle: 'Advanced Settings',
    negativePromptTitle: 'Negative Prompt',
    negativePromptPlaceholder: 'Enter or select elements you do not want in the image',
    generateCountTitle: 'Batch Size',
    cleanerTitle: 'Remove Foreground',
    maskSwitchViewButtonText: 'Switch View',
    regenerateButtonText: 'Regenerate',
    imageLoadingMessage: 'Loading image',
    maskGenerateFailedMessage: 'Failed to create mask',
    maskPreviewDialogConfirmButtonText1: 'Confirm cutout',
    maskPreviewDialogConfirmButtonText2: 'Create Mask',
    maskPreviewDialogCancelButtonText: 'Continue editing',
    objectRemovalDialogCancelButtonText: 'Continue editing',
    objectRemovalFailedMessage: 'Foreground removal failed',
    magicMaskGenerateFailedMessage: 'Failed to create smart mask',
    partMaskDialogTitle: 'Select Area',
    imageAnalyzingMessage: 'Analyzing image',
    cutout: 'Cutout',
    maskDialogConfirmButtonText1: 'Preparing preview',
    maskDialogConfirmButtonText2: 'Generate Preview',
    maskDialogConfirmTip: 'Stuck? Try again!',
    rangeOfChangeLabel: 'Adjustment Level',
    lesser: 'Low',
    more: 'High',
    disableModelDesc: 'Disable model, please ensure there is no model in the sketch',
    generateFailedMessage: 'Failed to create image generation task',
    taskNotEnoughTip:
      'The maximum number of simultaneous generation tasks has been reached. Please try again later.',
    saveTip1:
      'Saving {saveType} means that after saving the image, the clarity enhancement operation will automatically be performed.',
    saveTip2:
      'If the total number of ongoing LOOK and {saveType} tasks has reached the maximum number of simultaneous tasks, saving {saveType} operation will temporarily be unavailable.',
    promptButtonText1: 'AI Enhancement',
    promptButtonText2: 'Image Description',
    promptButtonMessage: 'Please enter a prompt first',
    promptButtonFailMessage: 'Generation failed, please try again',
    colorMatchTitle: 'Color Match',
    colorMatchSubject: 'Fashion Illustration to Photo',
    colorMatchDesc: 'Present the original color and texture of the fabric',
    patternExpansionSize: 'Expansion Size',
    patternExpansionSizeSmall: 'Small',
    patternExpansionSizeMedium: 'Medium',
    patternExpansionSizeLarge: 'Large',
    flowerPatternExpansionStep1: '1.Upload a non-continuous pattern',
    flowerPatternExpansionStep2: '2.Select the area to expand',
    flowerPatternExpansionStep3:
      '3.LOOK expands the edges of the pattern, turning the original pattern into a continuous pattern. It can be saved or downloaded for subsequent design.',
    maskCreateText: 'Create Mask'
  },
  cleaner: {
    maskDialogTitle: 'Select the area to erase',
    maskDesc: 'Select Erase Area'
  },
  drawing: {
    generatingMessage: 'Generating, please wait',
    startDrawingMessage: 'Please start drawing',
    waitingScreenMessage: 'Waiting for screen mirroring...',
    canvasCropperGuideMessage: 'Please crop the screen to the canvas size on the LOOK',
    startDrawingButtonText: 'Start designing',
    stopDrawingButtonText: 'Click to stop',
    videoNotSupportMessage: 'The current browser does not support video playback',
    canvasGuideMessage1:
      'Launch <img src="{image}" width="26" height="26" /> Procreate and turn <span style="font-weight: 700; text-decoration: underline">Canvas Broadcasting</span> off/on',
    canvasGuideMessage2: 'Canvas Broadcasting must be turned off and on again to work properly',
    castScreenGuideMessage1: 'The current version only supports',
    castScreenGuideMessage2: ' Procreate screen mirroring',
    castScreenGuideMessage2After: '',
    castScreenGuideMessage3:
      'Follow the guide to open the iPad screen mirroring connection {placeholder}',
    castScreenGuideMessage4: '(Both devices need to be on the same network)',
    screenPreviewTitle: 'Screen Casting Preview',
    reCropButtonText: 'Recrop'
  },
  hd: {
    scaleTitle: 'Enhance Image Quality',
    imageClaritySD: 'Save',
    imageClarityHD: 'Save in HD',
    imageClarityUHD: 'Save in UHD',
    imageClarityTextSD: 'SD',
    imageClarityTextHD: 'HD',
    imageClarityTextUHD: 'UHD',
    generatingMessage: ' Upscaling'
  },
  matte: {
    maskDialogTitle: 'Select area to keep',
    maskDesc: 'Select Area to Keep',
    magicLabel: 'Smart Cutout'
  },
  originality: {
    lineDrawingTitle: 'Sketch',
    lineDrawingUploadTitle: 'Upload Sketch',
    sampleClothesTitle: 'Sample Garment'
  },
  recolor: {
    maskDialogTitle: 'Select area to change color',
    maskDesc: 'Please select the area to change color',
    colorSelectTitle: 'Color Selection',
    getColorWarningMessage: 'The current browser does not support the color picker function'
  },
  styleFusion: {
    referenceImageDialogTitle1: 'Style Image'
  },
  background: {
    maskDialogTitle: 'Select area to keep',
    maskDesc: 'Select Area to Keep',
    backgroundDialogTitle: 'Add background',
    backgroundDescTitle: 'Background Description',
    promptInputPlaceholder: 'Enter background description to improve generation accuracy',
    referenceBackgroundTitle: 'Reference Background',
    intelligentFillLightLabel: 'Intelligent Lighting',
    backgroundGenerateTimeoutMessage: 'Background generation timeout, please try again',
    backgroundGenerateFailedMessage: 'Background generation failed, please try again',
    addBackgroundTitle: 'Add background',
    backgroundSizeTitle: 'Background size',
    effectPreviewMessage: 'Effect Preview',
    canvasEmptyMessage: 'Please add a background first'
  },
  text2Image: {
    textExampleMessage1:
      "A lookbook photo of an Italian model wearing oversized knitwear, featuring a close-up shot. The outfit is a plaid knit sweater made from yarns of different colors, representing a fashion brand's outdoor and streetwear. Photographed in the style of Campbell Addy, it's a high-fashion editorial shot.",
    textExampleMessage2:
      'A fashionable Chinese model wearing a flowing long dress in a modern Chinese style. The outfit features low-saturation colors and matching prints. It’s a runway look from Shanghai Fashion Week, showcasing a modern sense of fashion.',
    textExampleMessage3:
      'A close-up of a fashion model, featuring a garment with structural divisions, modern clothing, simple, clean, and flowing. The outfit is a mix of silk and linen fabrics, perfect for a fashion magazine cover photo.',
    textExampleMessage4:
      "A fashionable model is wearing a white shirt with exquisite embroidery. The shirt features large dark red floral patterns and golden embroidery details, adding a touch of vintage elegance. The model is wearing a pair of gold round earrings, with neatly styled hair swept back, revealing her face. The deep green background highlights the model's complexion and outfit, giving the overall image a strong artistic sense. The photo has a soft, low-saturation tone, creating a serene and poetic atmosphere.",
    textExampleMessage5:
      'A fashionable model solo, wearing a bright orange loose sweater made of thick knit material, featuring a high collar design and slightly loose sleeves. The bottom is a dark blue A-line leather skirt with a glossy finish and a firm texture. The model wears chunky platform high heels, adding a sense of heaviness. The look is completed with orange-framed sunglasses with blue lenses, giving the overall styling a futuristic and dramatic feel. The outfit features high-saturation colors with strong contrasts, creating a striking and bold visual effect. Accessories and makeup are unique and exaggerated, emphasizing personalization and artistry. The background is simple.',
    textExampleMessage6:
      'A young fashionable woman wearing a yellow fluorescent jacket, standing on a street in Japan, blue sky, natural light, upper body shot',
    textExampleMessage7:
      'An elegant white female model wearing a dark gray minimalist V-neck long coat and Martin boots, photographed in the style of Theo Angelopoulos. The coat is made of cashmere fabric from the brand Lemaire, featuring wrinkles, an overlapping front placket, and exuding a serene and sacred atmosphere. The scene is set in a foggy forest.',
    textExampleMessage8:
      'A fashionable woman wearing a bold green knitted sweater with a purple background. The sweater features a unique design with white and blue elements, resembling abstract faces. The fabric appears to be a thick knit, possibly wool or a wool blend, commonly used in this type of garment for warmth and texture. The fit is loose, with sleeves extending beyond the wrists, casual and oversized. The vibrant green dominates the overall look, contrasting with black pants to create an eye-catching color combination. The overall style is avant-garde and falls within contemporary street fashion.',
    textExampleMessage9:
      'A Korean fashion influencer is wearing a loose light blue denim shirt with wide sleeves. The shirt appears to have been distressed, featuring several rips and faded areas, indicating a vintage style. The model is also wearing light-colored shorts, possibly made of denim, matching the shirt. She has straight black long hair, a neutral expression, and is looking straight ahead. The background is light gray, highlighting the outfit. Film texture.',
    textExampleMessage10:
      'A Korean model stands in front of a minimalist background. She is wearing an oversized light olive green knitted cardigan with a hood, which looks very comfortable and casual. The cardigan is made of thick knit fabric and features a three-dimensional geometric pattern. The fit is loose, suitable for autumn or winter wear. The model also wears a dark brown baseball cap, with the logo on the cap clearly visible. Her expression is neutral, and her gaze is directed to one side, giving off a relaxed and easygoing vibe. The overall style leans towards casual and fashionable, emphasizing comfort and modernity. The photo has a film-like texture.',
    textExampleMessage11:
      'A model stands in front of a neutral background. She is wearing a unique off-white outfit with wide sleeves and an asymmetrical hem design, featuring multiple layers of fabric stacked in a style reminiscent of traditional Chinese clothing. The fabric is soft and fluid, with some texture, likely made from a lightweight cotton or silk blend. The fit is loose, offering a modern look that is both comfortable and stylish. The outfit is primarily off-white, with black pants providing contrast. The overall style leans towards minimalism with a touch of elegance. The model has a neat appearance, with a simple hairstyle and a calm expression, adding a sense of poise and confidence to the overall look.',
    generationRatioTitle: 'Image Ratio',
    tryText: 'Try It Out',
    freeProportionText: 'Free'
  },
  tune: {
    maskDialogTitle: 'Select the area to modify',
    maskDesc: 'Select Inpaint Area',
    promptTitle: 'Prompt'
  },
  pattern: {
    maskDialogTitle: 'Select the area to paste',
    maskDesc: 'Select Area to Paste',
    assistImagesTitle: 'Patterns'
  },
  modelTryOn: {
    modelImageDialogTitle1: 'Upload Model',
    modelImageDialogTitle2: 'Upload Clothes',
    maskDesc: 'Select the area to change clothes',
    maskDialogTitle: 'Select the area to change clothes',
    upperBodyTitle: 'Upper Body/Dress',
    dressTitle: 'Lower Body',
    loadingText: 'Smart selection in progress, please wait...',
    errorText: 'Smart selection failed, please try again',
    upperBodyMaskDialogTitle: 'Please select the area of the upper body/dress',
    dressMaskDialogTitle: 'Please select the area of the lower body',
    singleMaskDialogTitle: 'Please select the area of the model',
    single: 'Single Item',
    multi: 'Multiple Items',
    singleTitle: 'Single Item'
  },
  modelFace: {
    uploadImageTitle: 'Upload Original Image',
    maskDialogTitle: 'Paint the area of the person\'s face',
    maskDesc: 'Please paint the area of the person\'s face',
    selectModelTitle: 'Select Model',
    modelSelectorDesc: '<span style="color: #4c4c4c; font-size: 14px">Click to select model</span>',
    headSize: 'Head Size'
  },
  diyModel: {
    sex: 'Gender',
    male: 'Male',
    female: 'Female',
    age: 'Age',
    kid: '5',
    juvenile: '15',
    adult: '25',
    youth: '35',
    middleAged: '50',
    elderly: '60',
    color: 'Skin Tone',
    bodyShape: 'Body Type',
    hair: 'Hair',
    length: 'Length',
    hairstyle: 'Hairstyle',
    slenderBody: 'Slim',
    hourglassBody: 'Average',
    muscularBody: 'Muscular',
    babyFatBody: 'Chubby',
    shortAndFatBody: 'Short and Stocky',
    curvaceousBody: 'Curvy',
    straight: 'Straight',
    wavy: 'Wavy',
    curly: 'Curly',
    braided: 'Braided',
    naturallyCurly: 'Natural Curl',
    updo: 'Updo',
    airBangs: 'Air Bangs',
    dreadlocks: 'Dreadlocks',
    ponytail: 'Ponytail',
    bald: 'Bald',
    centerPartedHair: 'Middle Part',
    bangs: 'Full Bangs',
    frontBangs: 'Front Strands',
    short: 'Short',
    long: 'Long',
    shoulderLength: 'Shoulder-length',
    extraLongHair: 'Extra-long',
    pixieCut: 'Ear-length',
    collarboneLengthHair: 'Collarbone-length',
    shoulderLengthHair: 'Waist-length',
    waistLengthHair: 'Style',
    fairSkinWhite: 'Fair skin tone',
    darkSkin: 'Dark skin tone',
    yellowSkin: 'Yellow skin tone',
    asian: 'Asian',
    european: 'European',
    african: 'African',
    american: 'American',
    middleEastern: 'Middle-eastern'
  },
  maskDialogHelpTip: {
    mask: 'Click with the mouse to select the area to keep',
    matte:
      'Upload an image, click with the mouse to select the area to keep. If no cutout is needed, please click the confirm button directly.',
    cutout: 'Click with the mouse to select the area to keep',
    part: 'Click with the mouse to select the area to be used as a mask',
    objectRemoval:
      'To remove part of the foreground, click "Remove Foreground", then click with the mouse on the area to be removed. If not needed, click the "Confirm" button directly.'
  },
  subscribe: {
    subscribeTitle:
      'First subscription special&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">{discount}% OFF</span>&nbsp;discount',
    subscribeTitleFree:
      'First subscription gets you&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">{number}-Day Free Membership</span>',
    person: 'Person',
    month: 'Month',
    year: 'Year',
    currency: '$',
    mostPopularText: 'Most Popular',
    noMemberText: 'No Member',
    subscribeSubText:
      'Auto-renews after membership expires, <span style="color: #0d0d0d">returns to regular price next month</span>, can be canceled anytime',
    subscribeSubTextFree: 'Subscriptions can be canceled at any time with no extra fees',
    priceNegotiableText: 'Contact sales',
    tryThisText: 'Most Popular',
    payButtonText1: 'Subscribe',
    payButtonText1Free: '$0.00 Get {number}-Day Free Membership!',
    payButtonText2: 'Subscribe',
    payButtonText3: 'Upgrade Plan',
    payButtonText4: 'Current Plan',
    payButtonText5: 'Customer Service',
    payButtonText6: 'Edit Billing',
    payButtonText7: 'Subscribe',
    payMessage1: ' is the plan after the free trial ends',
    payMessage2: 'Activating',
    payMessage3: 'Payment after the 15-day trial ends',
    payMessage4: 'Pay',
    payMessage5: 'Please scan the QR code to complete the payment',
    payMessage6:
      'Automatic renewal at {currency}{amount}/month upon expiration, can be canceled at any time',
    payMessage7:
      'Upon trial expiration, automatically renew at {currency}{amount}/month, cancellable at any time',
    payMessage8: 'Please scan the QR code to complete the signing process',
    paySuccessText: 'Subscription successful',
    paySubText: 'Activation means agreement',
    freeMemberSuccessDesc:
      'Charges will be deducted after the 15-day membership trial ends. The subscription can be canceled at any time without additional fees.',
    receiveAwardTitle: '🎉Welcome to LOOK',
    receiveAwardTitleTaskGuide: '🎉1-Day Free Trial Received!',
    receiveAwardSubject:
      'We have prepared a<br><span style="font-size: 24px; font-weight: 700">{number}-day&nbsp;free trial</span>&nbsp;for you',
    receiveAwardSubjectTaskGuide:
      'Experience LOOK core features easily',
    receiveAwardTip: 'Want more?',
    receiveAwardButtonTextTaskGuide: 'Go to experience',
    receiveAwardButtonText: '{number}-day free trial for {currency}0.00',
    memberInvitedOnly: 'Invited Only',
    memberTipsStarter: 'Perfect for individual designers and AI newcomers.',
    memberTipsPlus: 'For experienced designers needing advanced AI tools.',
    memberTipsPro: 'For pros seeking full AI power and premium features.',
    memberFreeDesc1Label: 'Generated Images',
    memberFreeDesc1Value: '8 images/day',
    memberFreeDesc2Label: 'Resolution',
    memberFreeDesc2Value: 'Standard',
    memberFreeDesc3Label: 'Concurrent Tasks',
    memberFreeDesc3Value: '2',
    memberFreeDesc4Label: 'Real-Time Design',
    memberFreeDesc4Value: 'No',
    memberDescStarter0Label: 'Generation',
    memberDescStarter0Value: 'Unlimited',
    memberDescStarter1Label: 'Generation speed',
    memberDescStarter1Value: 'Normal',
    memberDescStarter2Label: 'Concurrent generations',
    memberDescStarter2Value: '{count}',
    memberDescStarter3Label: 'Generation Frequency',
    memberDescStarter3Value: '50 / 4 h',
    memberDescStarter4Label: 'Upscale frequency',
    memberDescStarter4Value: '8 / 4 h',
    memberDescStarter5Label: 'Upscale Image quality',
    memberDescStarter5Value: '2K',
    memberDescStarter6Label: 'Real-Time Design',
    memberDescStarter6Value: '1200 min / mo.',
    memberDescPlus0Label: 'Generation',
    memberDescPlus0Value: 'Unlimited',
    memberDescPlus1Label: 'Generation speed',
    memberDescPlus1Value: 'Fast',
    memberDescPlus2Label: 'Concurrent generations',
    memberDescPlus2Value: '{count}',
    memberDescPlus3Label: 'Generation Frequency',
    memberDescPlus3Value: '150 / 4 h',
    memberDescPlus4Label: 'Upscale frequency',
    memberDescPlus4Value: '16 / 4 h',
    memberDescPlus5Label: 'Upscale Image quality',
    memberDescPlus5Value: '3K',
    memberDescPlus6Label: 'Real-Time Design',
    memberDescPlus6Value: '3600 min / mo.',
    memberDescPro0Label: 'Generation',
    memberDescPro0Value: 'Unlimited',
    memberDescPro1Label: 'Generation speed',
    memberDescPro1Value: 'Turbo',
    memberDescPro2Label: 'Concurrent generations',
    memberDescPro2Value: '{count}',
    memberDescPro3Label: 'Generation Frequency',
    memberDescPro3Value: 'Unlimited',
    memberDescPro4Label: 'Upscale frequency',
    memberDescPro4Value: '48 / 4 h',
    memberDescPro5Label: 'Upscale Image quality',
    memberDescPro5Value: '4K',
    memberDescPro6Label: 'Real-Time Design',
    memberDescPro6Value: 'Unlimited',
    stripeConfirmMessage1: 'Processing Order',
    stripeConfirmMessage2: 'Please confirm if the subscription was successful?',
    stripeConfirmMessage3:
      'To verify your card is valid, we will place a {currency}1 pre-authorization on it.',
    stripeConfirmMessage4:
      'This is for verification only and <span style="font-weight: 600; color: #0d0d0d">will not result in any actual charges</span>, so please rest assured.',
    stripeSuccessMessage: 'Order completed!',
    stripeFailedMessage: 'Verification failed, please try again or change another payment method.',
    stripeConfirmButtonText: 'Completed Subscription',
    stripeCancelButtonText: 'Cancel',
    stripeEditBillingMessage: 'Billing subscription is being edited...',
    stripeEditBillingConfirmButtonText: 'Complete',
    stripeUpgradeMessage: 'Are you sure you want to upgrade your subscription?',
    stripeUpgradeSuccessMessage: 'Upgrade successful!',
    stripeSubscribeRenewButtonText: 'Resume Subscription',
    stripeSubscribeRenewConfirmMessage: 'Are you sure you want to resume the renewal?',
    stripeSubscribeRenewSuccessMessage: 'Subscription Resumed',
    stripeSubscribeCancelButtonText: 'Unsubscribe',
    stripeSubscribeCancelConfirmMessage: 'Are you sure you want to cancel the renewal?',
    stripeSubscribeCancelSuccessMessage: 'Subscription canceled',
    cancelQuestionaireTitle: 'Please select the reasons for unsubscribing (single choice).',
    cancelQuestionaireSubject:
      'Please choose one of the following options (single choice) to help us understand your reason for unsubscribing.',
    cancelQuestionaireSelection1: 'Just want to cancel the subscription',
    cancelQuestionaireSelection2: 'Price is too high',
    cancelQuestionaireSelection3: 'The service content no longer meets my needs',
    cancelQuestionaireSelection4: 'Poor user experience',
    cancelQuestionaireSelection5: 'Technical issues (e.g., frequent errors or interruptions)',
    cancelQuestionaireSelection6: 'Found a better alternative',
    cancelQuestionaireSelection7: 'Other (please specify)',
    cancelQuestionaireSelection8: 'The betters',
    cancelQuestionaireSubmiteButtonText: 'Submit',
    cancelQuestionaireCancelButtonText: "I'll use it a bit more",
    cancelSuccessMainTitle: 'Your subscription has been cancelled',
    cancelSuccessSubject: "You'll receive an email confirmation shortly.",
    reactivateTitle: "Didn't mean to cancel?",
    reactivateSubject: "No worries, let's get you reactivated!",
    reactivateButtonText: 'Reactivate now',
    upgradeTitle: 'Upgrade Plan',
    upgradeSubject: 'Your subscription upgrade will take effect immediately.',
    upgradeDesc:
      "The cost will be prorated based on the remaining days of the current month and deducted from the new plan's fee.",
    qrcodeTimeout: 'QR code expired',
    clickToRefresh: 'Click to retry',
    cycleText: 'Billed monthly',
    yearlyText: 'Billed annunal',
    paymentTypeMonthlyText: 'Monthly',
    paymentTypeYearlyText: 'Annually',
    freeUsageText: "Today's remaining free usage: {count}",
    currentSubscription: 'Current Subscription',
    expiredText: 'Renewal: {date}'
  },
  similer: {
    similerTitle: 'Visual Search',
    similerWaitingMessage: 'Component is initializing, please wait',
    similerSearchFailedMessage: 'Search failed, click to retry',
    similerNoSimilarMessage: 'No similar images found',
    similerLoadingMoreDetailImageError: 'High-resolution image not loaded, click to retry'
  },
  taskType: {
    generate: 'Image Generation',
    upscale: 'Upscale',
    realtimeDesign: 'Real-Time Design'
  },
  rewardTask: {
    rewardTaskListTitle1: 'Try core features to get 50% off membership',
    rewardTaskListTitle1Intl: 'Try Core Features',
    rewardTaskListDesc1: 'Bind Phone',
    rewardTaskListGuide1: 'Bind Phone',
    rewardTaskListDesc2: 'Create Project',
    rewardTaskListGuide2: 'Create Project',
    rewardTaskListDesc3: 'Sketch-to-Image',
    rewardTaskListGuide3:
      'Click or drag to upload images to transform sketches, style drawings, fashion illustrations, and real photos into realistic effects.',
    rewardTaskListDesc4: 'Sketch-to-Image (Color Match)',
    rewardTaskListGuide4:
      'In Sketch-to-Image, turning on <span style="color: #4c4c4c; font-weight: 600; text-decoration-line: underline">Color Match</span> <img src="{img}" style="vertical-align: middle;" /> will reference the original colors. If turned off, colors will be generated randomly.',
    rewardTaskListDesc5: 'Style Extension',
    rewardTaskListGuide5:
      'In Style Extension, AI can quickly create a series of variations based on your uploaded garment images.',
    rewardTaskListDesc6: 'Style Blending',
    rewardTaskListGuide6:
      'Style Blending requires uploading two images to merge clothing with inspiration materials, creating a fusion of different fashion styles.',
    rewardTaskListDesc7: 'Text-to-Image',
    rewardTaskListGuide7:
      'Enter a description of your design to generate a LOOK. You can use <img src="{img}" style="vertical-align: middle; width: 13px; height: 13px;" /> AI Polish and Image Description to help write descriptions.',
    getRewardButtonText1: 'Finish',
    sketchToImageInitPrompt:
      'A beautiful model wears an asymmetrical off-the-shoulder gown with a loose skirt with large pleats and waves, and a shiny fabric. Paired with a pair of dark pointed high heels, this dress exudes elegance and modernity, with a slightly metallic shiny fabric.',
    sketchToImageColorInitPrompt:
      'Fashion photo of the model wearing an elegant outfit consisting of a silver-grey linen long skirt, a black turtleneck sweater and a warm yellow checked vest. The outfit includes high thick-soled boots and a warm yellow and black checked belt with a large bow. The vest and skirt are decorated with geometric patterns. Her hair is combed high on her forehead and she wears sunglasses. Full-body shot.',
    styleExtensionInitPrompt:
      'A high-fashion garment featuring a structured, cropped blazer with sharp lapels and asymmetrical pocket details. on a white background. The blazer is paired with a draped, high-waisted skirt showcasing layered panels and flowing, asymmetrical hemlines. The design emphasizes an avant-garde silhouette with a mix of tailored precision and fluid draping. The material appears to be a lightweight, matte fabric, such as cotton or a cotton blend, giving it a soft yet structured appearance. The muted, earthy green color enhances the minimalist and contemporary aesthetic. The overall design reflects a balance between modern tailoring and artistic fluidity, perfect for runway or editorial fashion. product photography, detailed textures.',
    styleFusionInitPrompt:
      'A chunky knitted colorful sweater with a three-dimensional knitted bow pattern on the chest, against a white background.',
    text2ImageInitPrompt:
      'A model with black skin wearing an oversized blazer and leather skirt, long legs in boots with a giant bow on the back of her heels, posing for Vogue fashion photography against a white background. The image is hyper-realistic.',
    limitTime: 'Limited Time  ',
    guideStartButtonText: 'Generate',
    confirmCloseDialogTitle: 'Skip Tutorial',
    confirmCloseDialogDesc:
      'Are you sure you want to skip the tutorial? You won’t be able to view it again later.',
    confirmCloseDialogCancelButtonText: 'Cancel',
    confirmCloseDialogConfirmButtonText: 'Yes, Skip',
    rewardTitle: 'Your Design Boost Awaits!',
    rewardDescription: 'Use your coupon and explore fresh, powerful design features now.',
    couponType1: 'Discount',
    couponType2: 'Cash',
    expiredText: 'Valid Until: ',
    useNow: 'Use it Now!'
  },
  contextMenu: {
    copy: 'Copy',
    paste: 'Paste',
    selectAll: 'Select All'
  },
  login: {
    success: 'Hello, Designer!',
    closeWindow: 'You have successfully signed in. You can close this window now.'
  },
  update: {
    updateDialogTitle: 'Update Prompt',
    updateDialogMessage: 'Update available, do you want to update?',
    updateDialogCurrentVersion: 'Current Version',
    updateDialogNewVersion: 'New Version',
    updateDialogCancelButtonText: 'Not now',
    updateDialogUpdateButtonText: 'Update',
    updateDialogUpdateButtonLoadingText: 'Updating...'
  },
  updateError: {
    updateErrorDialogTitle: 'Update Failed',
    updateErrorDialogMessage: 'Update failed, please try again later.',
    updateErrorDialogButtonText: 'OK'
  },
  updateProgress: {
    updateProgressDialogTitle: 'Updating...'
  },
  remainingBalance: {
    realTimeDesign: 'Real-Time Design Hours',
    minute: 'min',
    hour: 'hours',
    frequency: 'Frequency',
    upscale: 'Upscale',
    last: 'last',
    image: 'images',
    unlimited: 'Unlimited'
  },
  compositor: {
    opacity: 'Opacity',
    saturation: 'Saturation',
    brightness: 'Brightness',
    contrast: 'Contrast',
    hue: 'Hue',
    depthMapFailed: 'Depth map generation failed, please upload the garment image again'
  },
  coupon: {
    couponListTitle: 'My Coupons',
    couponExpireCountdown: 'Remaining time: ',
    couponExpire: 'Valid until: ',
    couponListEmpty: 'No Coupons Available',
    couponListEmptyDescription1: 'Join our official Discord Channel',
    couponListEmptyDescription2: 'special events and offers!',
    couponListEmptyButton: 'Go To Discord'
  },
  plugins: {
    pluginsTitle: 'Plugin Store',
    addPluginButtonText: 'PIN',
    removePluginButtonText: 'UNPIN',
    addedPluginButtonText: 'PINNED',
    noImages: 'No plugin images',
    noPluginComponentText:
      'No plugin component found, please check if the plugin is correctly configured',
    editPluginsButtonText: 'Edit Plugin',
    editPluginsCompletedButtonText: 'Edit Completed',
    morePluginsButtonText: 'More Plugins',
    removePluginTipsTitle: 'Remove Plugin',
    removePluginTips1: 'The plugin can be added again from',
    removePluginTips2: '<span style="color: #0d0d0d; font-weight: 600;">Plugin Store</span>',
    pluginDisabled: 'Plugin is unavailable',
    pluginsTips: {
      title: 'LOOK AI',
      subtitle: 'PLUGIN STORE IS HERE!',
      plugintipTitle1: 'All-in-One Tools:',
      plugintipDesc1:
        'Say hello to our new Plugin Market! We’ve packed all your favorite features—Smart Recolor, AI Scene Change, Magic Erase, One-Click Cutout, and more—into one handy place. Just pin them, and they’re back in action!',
      plugintipTitle2: 'Customize Your Workspace:',
      plugintipDesc2:
        "Go to Plugin Market > Add Plugins > Click 'Edit Plugins' in the left toolbar, then drag & arrange icons however you want! Your LOOK, your rules!",
      plugintipTitle3: 'More Plugins Coming Soon!',
      plugintipDesc3:
        'Got ideas? Tell us what new tools you’d love, or share your feedback. LOOK is built for you, and we’re all ears!'
    },
    pluginsTipsFooter: {
      discord: 'Join our Discord Community',
      instagram: 'See more on Instagram',
      email: 'Email us: {email}'
    }
  }
}

export default en as any
